import React, { useState } from "react";
import PropTypes from 'prop-types';
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
// import { TimePicker } from "antd";

const ManageLocationModal = ({ setFormData, formData }) => {
  const [value, setValueTemp] = useState('');
  function setValue(phone = '') {
    setValueTemp(phone);
    setFormData({ ...formData, phone });
  }
  return (
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3">
            <label className="form-label">
              Location Title <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="title"
              required
              value={formData.title}
              className="form-control"
              onChange={(e) => {
                setFormData({ ...formData, [e.target.name]: e.target.value});
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label">
              Email <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              className="form-control"
              onChange={(e) => {
                setFormData({ ...formData, [e.target.name]: e.target.value});
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label">
              Phone Number <span className="text-danger">*</span>
            </label>
            <PhoneInput
              placeholder="Enter phone number"
              country="US"
              value={value ? value : formData.phone}
              onChange={setValue}
            />
          </div>
        </div>
        <div className="col-md-12">
          <div className="mb-3">
            <label className="form-label">
              Branch Address <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="location"
              required
              value={formData.location}
              className="form-control"
              onChange={(e) => {
                setFormData({ ...formData, [e.target.name]: e.target.value});
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label">
              City <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="city"
              required
              value={formData.city}
              className="form-control"
              onChange={(e) => {
                setFormData({ ...formData, [e.target.name]: e.target.value});
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label">
              Pincode <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="pinCode"
              required
              value={formData.pinCode}
              className="form-control"
              onChange={(e) => {
                setFormData({ ...formData, [e.target.name]: e.target.value});
              }}
            />
          </div>
        </div>
        <div className="col-md-12">
          <div>
              <h5 className="mt-3 mb-2">
                Pick/ Drop Charges
                <div style={{ float: 'right' }}>
                  <a
                    href="/"
                    className="btn btn-sm btn-success"
                    onClick={(e) => {
                      e.preventDefault();
                      const updatedCharges = [...formData.pickDropCharges];
                      const i = updatedCharges.length;
                        updatedCharges[i] = {
                          ...updatedCharges[i],
                          name: '',
                          address: '',
                          cost: '',
                        };
                        setFormData({ ...formData, pickDropCharges: updatedCharges});
                    }}
                  >
                    <i className="fa fa-plus"></i>
                  </a>
                </div>
                <div style={{ clear: 'both' }}></div>
              </h5>
              {formData.pickDropCharges && formData.pickDropCharges.map((s, index) => (
                <div key={index} className="row">
                  <div className="col-md-4">
                    <div className="mb-3 form-group">
                      <label className="form-label">Location Name</label>
                      <input
                        type="text"
                        name="name"
                        required
                        value={s.name}
                        className="form-control"
                        onChange={(e) => {
                          const updatedCharges = [...formData.pickDropCharges];
                          updatedCharges[index] = {
                            ...updatedCharges[index],
                            name: e.target.value, // Replace 'name' with the actual key you want to update
                          };
                          setFormData({ ...formData, pickDropCharges: updatedCharges});
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3 form-group">
                      <label className="form-label">Address</label>
                      <input
                        type="text"
                        name="address"
                        required
                        value={s.address}
                        className="form-control"
                        onChange={(e) => {
                          const updatedCharges = [...formData.pickDropCharges];
                          updatedCharges[index] = {
                            ...updatedCharges[index],
                            address: e.target.value, // Replace 'name' with the actual key you want to update
                          };
                          setFormData({ ...formData, pickDropCharges: updatedCharges});
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-3 form-group">
                      <label className="form-label">Cost</label>
                      <input
                        type="number"
                        name="cost"
                        required
                        value={s.cost}
                        className="form-control"
                        onChange={(e) => {
                          const updatedCharges = [...formData.pickDropCharges];
                          updatedCharges[index] = {
                            ...updatedCharges[index],
                            cost: e.target.value, // Replace 'name' with the actual key you want to update
                          };
                          setFormData({ ...formData, pickDropCharges: updatedCharges});
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-3 form-group">
                      <label className="form-label d-block">&nbsp;</label>
                      <a
                        href="/"
                        className="btn btn-danger"
                        onClick={(e) => {
                          e.preventDefault();
                          const updatedCharges = formData.pickDropCharges.filter((_, i) => i !== index);
                          setFormData({ ...formData, pickDropCharges: updatedCharges });
                        }}
                      >
                        <i className="fa fa-minus"></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
  );
};

ManageLocationModal.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default ManageLocationModal;
